import {
  TableDropDownContainer,
  TableRowHeader,
} from './styles/AXSTableHead.styled';

interface AXSTableHeadProps {
  headerData: JSX.Element[];
}

export const AXSTableHead = ({ headerData }: AXSTableHeadProps) => {
  return (
    <TableRowHeader>
      <TableDropDownContainer>
        {headerData.map((headerSelect) => headerSelect)}
      </TableDropDownContainer>
    </TableRowHeader>
  );
};
